import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=25be66e2&scoped=true&"
import script from "./NavItem.vue?vue&type=script&lang=js&"
export * from "./NavItem.vue?vue&type=script&lang=js&"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=25be66e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be66e2",
  null
  
)

export default component.exports